class ScrollService {
    public scrollToTop() {
        window.scrollTo(0, 0);
    }

    public scrollToElement(element: HTMLElement, offset: number = 0, duration: number = 200, scrollElement: HTMLElement | undefined = undefined) {
        duration === 0
            ? this.simpleScroll(element.offsetTop + offset, scrollElement)
            : this.animateScroll(element.offsetTop + offset, duration, scrollElement);
    }

    public simpleScroll(to: number, scrollElement: HTMLElement | undefined = undefined) {
        if (scrollElement) {
            scrollElement.scrollTop = to;
        } else {
            window.scrollTo(0, to);
        }
    }

    public animateScroll(to: number, duration: number, scrollElement: HTMLElement | undefined = undefined) {
        const startingY = scrollElement ? scrollElement.scrollTop : window.pageYOffset;
        const diff = to - startingY;
        let start: number;
        window.requestAnimationFrame(function step(timestamp) {
            if (!start) {
                start = timestamp;
            }
            const time = timestamp - start;
            const percent = Math.min(time / duration, 1);

            if (scrollElement) {
                scrollElement.scrollTop = startingY + diff * percent;
            } else {
                window.scrollTo(0, startingY + diff * percent);
            }

            if (time < duration) {
                window.requestAnimationFrame(step);
            }
        });
    }
}

export default new ScrollService();
